var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CampaignForm',{attrs:{"campaign":_vm.campaign,"errors":_vm.errors,"title":_vm.title,"load-data":_vm.loadData,"is-saving-form":_vm.isSavingForm},on:{"submit":_vm.update,"setBackUrl":_vm.setBackUrl}})}
var staticRenderFns = []

export { render, staticRenderFns }